import { render, staticRenderFns } from "./historico-apoyos.vue?vue&type=template&id=7bfbb653&scoped=true&"
import script from "./historico-apoyos.component.ts?vue&type=script&lang=ts&"
export * from "./historico-apoyos.component.ts?vue&type=script&lang=ts&"
import style0 from "./historico-apoyos.vue?vue&type=style&index=0&id=7bfbb653&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfbb653",
  null
  
)

export default component.exports